export const IStaff = {
  id: 17,
  images: [1],
  icon: 'UpdatedIcon',
  image_type: 0,
  first_name: 'Reza',
  surname: 'Test 2',
  language_code: 'fr-FR',
  date_of_birth: '1990-02-02T00:00:00.000Z',
  email: 'john.updated17@example.com',
  contact_number: '7702299999',
  contact_number_code: '+4',
  address: {
    line1: 'line1',
    line2: 'line2',
    city: 'city',
    country: 'country',
    postcode: 'postcode',
  },
  has_login: false,
  display_name: 'Al',
  passcode: '1332',
  emergency_contact_name: 'Emergency 1',
  emergency_contact_number: '1987654322',
  emergency_contact_number_code: '+44',
  role_id: 1,
  last_user_id: 38,
  is_archive: false,
  created_at: '2023-11-21T14:46:21.132Z',
  updated_at: '2023-11-29T14:59:37.454Z',
  archived_at: null,
  is_active: true,
  store_ids: [56],
  role_name: 'Role 11',
}

export const IStaffUpsertArgs = {
  id: 1,
  store_ids: [56],
  icon: '',
  image_type: 0,
  first_name: '',
  surname: '',
  language_code: '',
  date_of_birth: null,
  email: '',
  contact_number: '',
  contact_number_code: '+44',
  address: {},
  has_login: false,
  display_name: '',
  passcode: '',
  emergency_contact_name: '',
  emergency_contact_number: '',
  emergency_contact_number_code: '',
  role_id: -1,
}

export const IRole = {
  id: 1,
  name: 'Role 1',
  access: [1, 2, 3],
  last_user_id: 32,
  is_archive: false,
  created_at: '2023-11-27T12:14:21.078Z',
  updated_at: '2023-11-27T12:17:47.011Z',
  archived_at: '2023-11-27T12:16:50.410Z',
}
